import { useEffect, useState } from "react";
import { useQuery } from "../Utils";
import Project from "../models/Project";

const DEFAULT_AUTH_REDIRECT_URL_VARIANT = "projects-list";
const DEFAULT_REDIRECT_URL = "/app";

const useAppRedirectionUrl = ({ userData }) => {
  const [redirectUrl, setRedirectUrl] = useState(null);
  const query = useQuery();

  useEffect(() => {
    (async () => {
      if (!userData?.data) {
        return;
      }

      if (window.location.pathname.startsWith('/authenticate_mobile')) {
        return;
      }

      const { authRedirectUrl: authRedirectUrlVariant = DEFAULT_AUTH_REDIRECT_URL_VARIANT } = userData.data;
      let url = DEFAULT_REDIRECT_URL;
      if (!query.has("fromAuth")) {
        setRedirectUrl(url);
        return;
      }

      switch (authRedirectUrlVariant) {
        case "first-project": {
          const firstProject = await Project.getFirst(userData.userId);
          if (firstProject) {
            url = `/app/project/${firstProject.id}`;
          }
          break;
        }

        case "projects-list":
        default:
          break;
      }

      setRedirectUrl(url);
    })();
  }, [query, userData]);

  return redirectUrl;
};

export default useAppRedirectionUrl;
